import { FolderContent } from '@/api/generatedApi';
import { StyledList, StyledListItem } from '@/components/AssetsPage/PopoverList';
import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { Divider, ListItemIcon, ListItemText } from '@mui/material';

interface DeleteItemMenuContentProperties<T extends FolderContent> {
  clickedItem?: T;
  onClose: () => void;
  onDeleteClick: (item: T) => void;
  sx?: object;
}

export const DeleteItemMenuContent = <T extends FolderContent>({
  clickedItem,
  onClose,
  onDeleteClick,
  sx,
}: DeleteItemMenuContentProperties<T>) => {
  const { permissions } = useGetCurrentUser();

  if (!permissions.canDeleteAssets || !clickedItem) {
    return;
  }

  const handleDeleteClick = () => {
    onDeleteClick(clickedItem);
    onClose();
  };

  const getDeleteText = () => {
    if (clickedItem.contentType === 'asset') {
      return 'Delete Asset';
    } else if (clickedItem.contentType === 'folder') {
      return 'Delete Folder';
    }
    return 'Delete';
  };

  return (
    <StyledList sx={sx}>
      <Divider />
      <StyledListItem onClick={handleDeleteClick}>
        <ListItemIcon>
          <DeleteIcon sx={{ fontSize: '18px' }} />
        </ListItemIcon>
        <ListItemText>{getDeleteText()}</ListItemText>
      </StyledListItem>
    </StyledList>
  );
};
